// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Mc0w","content":"RecentSearches_content__2G--c"};